import { Component } from '@angular/core';

@Component({
  selector: 'app-social-dinner26',
  templateUrl: './social-dinner26.component.html',
  styleUrl: './social-dinner26.component.css'
})
export class SocialDinner26Component {

}
